import createVueApp from '@/common/createApp'

Styxie.Initializers.PaymentData = {
  edit: async(props) => {
    const { default: PaymentDataEdit } = await import('@/vue_widgets/payment_data/edit/index.vue')
    createVueApp(PaymentDataEdit, { props, layout: null })
  }
}
